// extracted by mini-css-extract-plugin
module.exports = {"scaleDesc":"styles_scaleDesc__c_V_o"};